function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-36d532a3\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?indentedSyntax!residential/sass/result-insurer.scss")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PartialInsurerAdditionalProduct.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-36d532a3\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PartialInsurerAdditionalProduct.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36d532a3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/enterprise/modules/Result/PartialInsurerAdditionalProduct.vue
// module id = 172
// module chunks = 0